import { BulletProps } from "./types";

export const Bullet: React.FC<BulletProps> = ({ fillColor, strokeColor, style }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M19.2788 3.50693L28.7407 12.9688C30.4843 14.7124 30.4843 17.5352 28.7407 19.2788L19.2788 28.7407C17.5351 30.4843 14.7124 30.4843 12.9688 28.7407L3.50693 19.2788C1.76331 17.5352 1.76331 14.7124 3.50693 12.9688L12.9688 3.50693C14.7124 1.76331 17.5351 1.76331 19.2788 3.50693Z"
        fill={fillColor ?? "#44E4FF"}
      />
      <path
        d="M12.7982 3.20176L3.20173 12.7983C1.43345 14.5666 1.43347 17.4335 3.20175 19.2018L12.7983 28.7983C14.5665 30.5665 17.4335 30.5666 19.2017 28.7983L28.7982 19.2018C30.5665 17.4335 30.5665 14.5665 28.7982 12.7983L19.2017 3.20176C17.4335 1.43348 14.5665 1.43348 12.7982 3.20176Z"
        stroke={strokeColor ?? "#0045B5"}
        strokeWidth="3"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
